<h4 *ngIf="title!=null">{{title}}</h4>

<ng2-smart-table
  [title]="title"
  [settings]="settings"
  [source]="source"
  (createConfirm)="editConfirm.emit($event)"
  (editConfirm)="editConfirm.emit($event)"
  (deleteConfirm)="deleteConfirm.emit($event)"
></ng2-smart-table>

<!--6 loops for coil # 528494 were sent to NRVI (arrival Thursday, 22nd of November). NRVI prpared the recipe and formed one first coil.
-->
